import { IComplaintsAndSuggestionsState } from '../states'
import { SuggestionsActionTypes, SuggestionsTypeKeys } from '../types'

export const initialComplaintsAndSuggestionsState: IComplaintsAndSuggestionsState = {
  isLoading: false
}

const complaintsAndSuggestions = (
  state: IComplaintsAndSuggestionsState = initialComplaintsAndSuggestionsState,
  action: SuggestionsActionTypes
): IComplaintsAndSuggestionsState => {
  switch (action.type) {
    case SuggestionsTypeKeys.IS_LOADING_SUGGESTIONS:
      return { ...state, isLoading: action.payload }
    default:
      return state
  }
}

export default complaintsAndSuggestions
